/* global axios */
import ApiClient from './ApiClient';

class BankSettingsAPI extends ApiClient {
  constructor() {
    super('bank_settings', { accountScoped: true });
  }
}

export default new BankSettingsAPI();
